export const BASE_URL = '/cyber'
